// extracted by mini-css-extract-plugin
module.exports = {"container":"BotPerformanceReport_container__15ixA","backBtn":"BotPerformanceReport_backBtn__1FLpk"};